import { ContentfulEntry } from 'blades/widgetTypes';
import contentfulClient from 'models/Contentful';
import { request } from 'utils';
import { ApiResponse } from 'models/@types';
import { IQuickstartMenu } from './@types';

/* eslint-disable import/prefer-default-export */
export const getQuickstartMenu = async (
  identifier: string,
): Promise<ContentfulEntry<IQuickstartMenu>[]> => {
  const result = await contentfulClient.getEntries<ContentfulEntry<IQuickstartMenu>>({
    content_type: 'quickstartMenu',
    'fields.identifier': identifier,
    include: 10,
  } as any);
  return result.items as unknown as ContentfulEntry<IQuickstartMenu>[];
};

export const markStepAsCompleted = async (stepId: string) => {
  return request<ApiResponse<{ success: boolean }>>({
    url: `complete-onboarding-task`,
    method: 'POST',
    data: { stepId },
  });
};
